import { inject } from 'vue'
import { App } from './types/App'

export function getApp (): Partial<App> {
  const app = inject<Partial<App>>('vue-service:app')

  if (!app) {
    throw new Error('could not find the app. This error usually occurs when "getApp()" is called in configuration.')
  }

  return app
}
